import { Card, Link, Stack, Typography } from "@mui/material";
import MuiButton from "@mui/material/Button";
import LocalPhone from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import LaunchIcon from "@mui/icons-material/Launch";
import SchoolIcon from "@mui/icons-material/School";
import { a, useTrail } from "@react-spring/web";
import PropTypes from "prop-types";

const Button = (props) => <MuiButton variant="outlined" {...props} />;

const items = [
  {
    title: "Submit Ticket",
    titleIcon: <LiveHelpIcon />,
    body: "If you can't find a solution to  your problems in our knowledge base, you can submit a ticket by selecting the appropriate department below.",
    actionButton: (
      <Link href="help/submit-ticket" sx={{ textDecoration: "none" }}>
        <Button>Start Here</Button>
      </Link>
    )
  },
  {
    title: "Knowledge Base",
    titleIcon: <SchoolIcon />,
    body: "We are here. You can search our knowledge base for any doubts, email or call us per your convenience.",
    actionButton: <Button endIcon={<LaunchIcon />}>Knowledge Base</Button>
  },
  {
    title: "Email Us",
    titleIcon: <MailOutlineIcon />,
    body: "Drop us an email at help@keywordsfly.com",
    actionButton: <></>
  },
  {
    title: "Call Us",
    titleIcon: <LocalPhone />,
    body: "Call us on ou helpline number below (Sun-Sat 10:30AM to 7:00PM IST)",
    actionButton: (
      <Link href="tel:+918537675415" sx={{ textDecoration: "none" }}>
        <Button>Call +91 8537675415</Button>
      </Link>
    )
  }
];

export default function HelpCenter() {
  const trail = useTrail(items.length, {
    config: { mass: 5, tension: 2000, friction: 200 },
    opacity: 1,
    x: 0,
    width: "23%",
    from: { opacity: 0, x: 20 }
  });

  return (
    <Card sx={{ p: 2 }}>
      <Typography textAlign="center" fontWeight={400} variant="h2">
        Looking for help?
      </Typography>
      <Typography sx={{ color: "gray" }} textAlign="center" variant="h6">
        We are here. You can search our knowledge base for your doubts, Email or
        call us as per your connvenience.
      </Typography>
      <Stack direction="row" justifyContent="space-between">
        {trail.map((style, index) => (
          <a.div style={style} key={index}>
            <Item item={items[index]} />
          </a.div>
        ))}
      </Stack>
    </Card>
  );
}

const Item = ({ item }) => (
  <Card
    raised={false}
    sx={{
      color: "gray",
      p: 2,
      borderRadius: 0,
      border: "1px solid gray",
      textAlign: "center"
    }}
  >
    <Stack>
      <Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          {item.titleIcon} {item.title}
        </Stack>
      </Typography>
      <br />
      <Typography>{item.body}</Typography>
      {item.actionButton}
    </Stack>
  </Card>
);

Item.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string,
    titleIcon: PropTypes.node,
    actionButton: PropTypes.node
  })
};
